export enum DeploymentClass {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export const deploymentClasses = Object.values(DeploymentClass);
